module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc__share"
  }, [_c('div', {
    staticClass: "m-mini-calc-icon--print"
  }, [_c('svg', {
    staticClass: "m-mini-calc-icon m-mini-calc-icon--dark",
    attrs: {
      "viewBox": "0 0 120 120"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#print"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bba8d6d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/MiniCalculatorPrint.vue
// module id = 1733
// module chunks = 0